import React, { Component } from "react";
import PropTypes from "prop-types";
import Info from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import * as Theme from "../../../app/Theme";
// import { RESTService } from "../../../api/old/server_calls";
import TLabel from "../../common/TLabel";
import TComboBox from "../../common/TComboBox";
import TDialog from "../../common/TDialog";
import TWifiAnimation from "../../common/TWifiAnimation";
import GbStdTable from "../../common/GBStdTableAG/GbStdTable";
import { getDelphiHexFromHexColor, toBase10 } from "../../GB/GBUtil";
import * as GBConst from "../../GB/GBConst";
import * as HLConst from "../NonVisual/HLConst";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";
import HLIntervTreeDialog from "../Other/HLIntervTreeDialog";
import {
    getAgeGroupStr,
    getCountryMstIDs,
    getCountryIdx,
    getCountryNames,
    getScaleUpScenarioText,
    // firstYearPopEquals100,
    // intervAreaChecked,
    // getStuntingPerc,
    // getWastingPerc,
    // getScaledIntervObjList,
    // scaleUpNotSelected,
} from "../NonVisual/HLUtil";
import TButton from "../../common/TButton";

const indent = 10;

// const paperStyle = {
//     height: 350,
//     width: 275,
//     margin: indent,
//     padding: 10,
// };

// const paperInstructionStyle = {
//     margin: 0,
// };

/* Intervention Area table */

const intervAreaTable = {
    hiddenCol: 1,
    checkBoxCol: 2,
    intervAreaCol: 3,
    scaleUpCol: 4,

    numHeaderRows: 1,

    hiddenColWidth: 0,
    includeColWidth: 100,
    intervAreaColWidth: 375,
    scaleUpColWidth: 200,
};

/* First year population table */

const firstYearPopTableC = {
    ageCol: 1,
    maleCol: 2,
    femaleCol: 3,

    numHeaderRows: 1,
};

class HLStep2Form extends Component {
    static propTypes = {
        countryCodeInt: PropTypes.number,
        onCountryChange: PropTypes.func,

        countryObjList: PropTypes.arrayOf(PropTypes.object),

        onDrawerChange: PropTypes.func,

        firstYearPop2DIntArray: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
        onFirstYearPopChange: PropTypes.func,

        intervAreaObjList: PropTypes.arrayOf(PropTypes.object),
        onIncludeIntervAreaChange: PropTypes.func,
        onIntervAreaScaleUpChange: PropTypes.func,

        intervObjList: PropTypes.arrayOf(PropTypes.object),

        onPageChange: PropTypes.func,

        recalcBool: PropTypes.bool,
        onRecalcChange: PropTypes.func,

        onRankedIntervMstIDArrayChange: PropTypes.func,

        onResultWkbkFileURLChange: PropTypes.func,

        showChildrenIntervBool: PropTypes.bool,
        onShowChildrenIntervChange: PropTypes.func,

        showMaternalIntervBool: PropTypes.bool,
        onShowMaternalIntervChange: PropTypes.func,

        stuntingIndCurrID: PropTypes.number,
        onStuntingIndChange: PropTypes.func,

        wastingIndCurrID: PropTypes.number,
        onWastingIndChange: PropTypes.func,
    };

    static defaultProps = {
        countryCodeInt: 0,
        onCountryChange: () => console.log("onCountryChange"),

        countryObjList: [],

        onDrawerChange: () => console.log("onDrawerChange"),

        firstYearPop2DIntArray: [],
        onFirstYearPopChange: () => console.log("onFirstYearPopChange"),

        intervAreaObjList: [],
        onIncludeIntervAreaChange: () => console.log("onIncludeIntervAreaChange"),
        onIntervAreaScaleUpChange: () => console.log("onIntervAreaScaleUpChange"),

        intervObjList: [],

        onPageChange: () => console.log("onPageChange"),

        onRankedIntervMstIDArrayChange: () => console.log("onRankedIntervMstIDArrayChange"),

        recalcBool: true,
        onRecalcChange: () => console.log("onRecalcBool"),

        onResultWkbkFileURLChange: () => console.log("onResultWkbkFileURLChange"),

        showChildrenIntervBool: true,
        onShowChildrenIntervChange: () => console.log("onSHowChildrenIntervChange"),

        showMaternalIntervBool: true,
        onShowMaternalIntervChange: () => console.log("onSHowChildrenIntervChange"),

        stuntingIndCurrID: HLConst.unsureNA_NutStatStunt,
        onStuntingIndChange: () => console.log("onStuntingIndChange"),

        wastingIndCurrID: HLConst.unsureNA_NutStatWast,
        onWastingIndChange: () => console.log("onWastingIndChange"),
    };

    state = {
        changingCountry: false,
        calculating: false,
        showIntervTreeDialog: false,
        //firstYearPopTableRef : React.createRef(), // markRef
    };

    // markRef
    // componentDidMount () {
    //
    //     this.props.passData({
    //
    //         firstYearPopTableRef : this.state.firstYearPopTableRef,
    //
    //     });
    //
    // };

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    // markRef
    // onNormalizeBtnClick = () => {
    //
    //     const params = {
    //         columnIds     : ["field2", "field3"],
    //         firstRowIndex : 1,
    //         lastRowIndex  : 4,
    //     };
    //
    //     //this.state.firstYearPopTableRef.current.onNormalize();
    //     normalize(params, this.state.firstYearPopTableRef.current);
    //
    // };

    onIntervAreaInfoClick = () => {
        this.setState({
            showIntervTreeDialog: true,
        });
    };

    onIntervAreaDialogClose = () => {
        this.setState({
            showIntervTreeDialog: false,
        });
    };

    onStuntingComboBoxChange = (value, text, info) => {
        this.props.onStuntingIndChange(value + 1);
    };

    onWastingComboBoxChange = (value, text, info) => {
        this.props.onWastingIndChange(value + 1);
    };

    // NOTE: Default server is dead since Feb 2025
    // onViewResultsBtnClick = () => {
    //     /* Constants */
    //     const sex = GBConst.sex;

    //     /* Props */
    //     const props = this.props;
    //     const countryCodeInt = props.countryCodeInt;
    //     const firstYearPop2DIntArray = props.firstYearPop2DIntArray;
    //     const intervObjList = props.intervObjList;
    //     const intervAreaObjList = props.intervAreaObjList;
    //     const stuntingIndCurrID = props.stuntingIndCurrID;
    //     const wastingIndCurrID = props.wastingIndCurrID;
    //     const recalcBool = props.recalcBool;

    //     try {
    //         const stuntingPerc = getStuntingPerc(stuntingIndCurrID);
    //         const wastingPerc = getWastingPerc(wastingIndCurrID);

    //         const countrySelected = countryCodeInt !== HLConst.noCountrySelected;
    //         const maleFirstYearPopEquals100 = firstYearPopEquals100(firstYearPop2DIntArray, sex.male);
    //         const femaleFirstYearPopEquals100 = firstYearPopEquals100(firstYearPop2DIntArray, sex.female);
    //         const intervAreaCheckedV = intervAreaChecked(intervAreaObjList);
    //         const scaleUpNotSelectedV = scaleUpNotSelected(intervAreaObjList);

    //         const scaledIntervObjList = getScaledIntervObjList(intervAreaObjList, intervObjList);

    //         /* Do not let users view results if they haven't
    //             1. Picked a country.
    //             2. Selected at least one intervention area to include in the analysis.
    //             3. Made the first year population proportion sum to 100%.
    //          */
    //         if (!countrySelected) {
    //             alert("Please select a host country");
    //         } else if (!intervAreaCheckedV) {
    //             alert("Please select one or more intervention areas.");
    //         } else if (scaleUpNotSelectedV) {
    //             alert(
    //                 "A scale-up scenario must be selected for each intervention area you wish to include in your analysis."
    //             );
    //         } else if (!maleFirstYearPopEquals100) {
    //             alert("The first year population must total 100% for males.");
    //         } else if (!femaleFirstYearPopEquals100) {
    //             alert("The first year population must total 100% for females.");
    //         } else {
    //             if (recalcBool) {
    //                 this.setState(
    //                     {
    //                         calculating: true,
    //                     },
    //                     () => {
    //                         const params = {
    //                             countryCode: countryCodeInt,
    //                             firstYearPop: firstYearPop2DIntArray,
    //                             scaledIntervObjList: scaledIntervObjList,
    //                             firstYearStuntingCov: stuntingPerc,
    //                             firstYearWastingCov: wastingPerc,
    //                         };

    //                         RESTService.getRankedIntervs(
    //                             params,
    //                             (response, GUID, linkToken) => {
    //                                 this.setState({
    //                                     calculating: false,
    //                                 });

    //                                 this.props.onRankedIntervMstIDArrayChange(response["rankedIntervArray"], () => {
    //                                     const path =
    //                                         window.API_URL_BASE + "/r/" + linkToken + "/" + response["wkbkFileURL"];

    //                                     this.props.onResultWkbkFileURLChange(path, () => {
    //                                         this.setState(
    //                                             {
    //                                                 calculating: false,
    //                                             },
    //                                             () => {
    //                                                 this.props.onRecalcChange(false, () => {
    //                                                     this.props.onDrawerChange(HLConst.resultsDrawer);
    //                                                 });
    //                                             }
    //                                         );
    //                                     });
    //                                 });
    //                             },
    //                             () => {
    //                                 this.setState(
    //                                     {
    //                                         calculating: false,
    //                                     },
    //                                     () => alert("An error occurred while retrieving results.")
    //                                 );
    //                             }
    //                         );
    //                     }
    //                 );
    //             } else {
    //                 this.props.onDrawerChange(HLConst.resultsDrawer);
    //             }
    //         }
    //     } catch (err) {
    //         this.setState(
    //             {
    //                 calculating: false,
    //             },
    //             () => alert("An unexpected error has occurred: " + <br></br> + <br></br> + err)
    //         );
    //     }
    // };

    onScaleUpComboBoxChange = (value, text, info) => {
        if (value !== HLConst.noScaleUpSelected) {
            this.props.onIntervAreaScaleUpChange(info, value);
        }
    };

    onIntervAreaPackTableChange = (newPackTable) => {
        const intervAreaObjList = this.props.intervAreaObjList;

        let stopBool = false;
        let i = 1;

        while (i <= intervAreaObjList.length && !stopBool) {
            const oldIncludeBool = intervAreaObjList[i - 1].includeBool;
            const newIncludeBool = newPackTable.CheckBoxState[i][intervAreaTable.checkBoxCol - 1];

            if (oldIncludeBool !== newIncludeBool) {
                this.props.onIncludeIntervAreaChange(i, newIncludeBool);
                stopBool = true;
            }

            i++;
        }
    };

    onFirstYearPopPackTableChange = (newPackTable) => {
        try {
            /* Constants */
            // const sex = GBConst.sex;

            const newPackTableClone = JSON.parse(JSON.stringify(newPackTable));
            const values2DArray = newPackTableClone.tableData.value;

            let firstYearPop2DIntArray = [];

            for (let a = 1; a <= HLConst.numAgeGroups; a++) {
                firstYearPop2DIntArray.push([]);

                for (let s = 1; s <= GBConst.numSexes; s++) {
                    firstYearPop2DIntArray[a - 1].push(values2DArray[a][s]);
                }
            }

            this.props.onFirstYearPopChange(firstYearPop2DIntArray);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    // NOTE: Default server is dead since Feb 2025
    // onCountryComboBoxChange = (value, text, info) => {
    //     if (info !== HLConst.noCountrySelected) {
    //         this.setState(
    //             {
    //                 changingCountry: true,
    //             },
    //             () => {
    //                 this.props.onCountryChange(info, () => {
    //                     const params = {
    //                         countryCode: info,
    //                     };

    //                     RESTService.getFirstYearPopData(
    //                         params,
    //                         (response) => {
    //                             this.props.onFirstYearPopChange(response, () => {
    //                                 this.setState({
    //                                     changingCountry: false,
    //                                 });
    //                             });
    //                         },
    //                         () => alert("An error occurred while retrieving the first year population.")
    //                     );
    //                 });
    //             }
    //         );
    //     }
    // };

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderIntervAreasTable = () => {
        let intervAreasTable;

        /* Constants */
        const hAlign = GBConst.hAlign;
        const english = GBConst.language.english;
        const intervAreaObjC = HLConst.intervAreaObj;
        // const diseaseAreaObjListC = HLConst.diseaseAreaObjList;
        // const intervObjC = HLConst.intervObj;

        /* Props */
        const props = this.props;
        const intervAreaObjList = props.intervAreaObjList;

        // const hiddenCol = intervAreaTable.hiddenCol;
        const checkBoxCol = intervAreaTable.checkBoxCol;
        const intervAreaCol = intervAreaTable.intervAreaCol;
        const scaleUpCol = intervAreaTable.scaleUpCol;
        const numCols = scaleUpCol;

        const numHeaderRows = intervAreaTable.numHeaderRows;

        const hiddenColWidth = intervAreaTable.hiddenColWidth;
        const includeColWidth = intervAreaTable.includeColWidth;
        const intervAreaColWidth = intervAreaTable.intervAreaColWidth;
        const scaleUpColWidth = intervAreaTable.scaleUpColWidth;

        const numRows = intervAreaObjList.length + numHeaderRows;

        let frameworkComponents = {};

        const addFrameworkComponent = (frameworkComponents, key, newComponent) => {
            return {
                ...frameworkComponents,
                [key]: newComponent,
            };
        };

        const GetScaleUpComboBox = ({ intervAreaCurrID, row }) => {
            /* Needs to be declared here again or the combobox will use the props from before onScaleUpComboBoxChange
               gets fired.  */
            const intervAreaObjList = this.props.intervAreaObjList;

            let scaleUp1DStrArray = [];
            let intervAreaCurrID1DIntArray = [];

            for (let i = 0; i <= HLConst.numScaleUpScenarios; i++) {
                scaleUp1DStrArray.push(getScaleUpScenarioText(i));
                intervAreaCurrID1DIntArray.push(intervAreaCurrID);
            }

            const scaleUpComboBox = (
                <TComboBox
                    onChange={this.onScaleUpComboBoxChange}
                    info={intervAreaCurrID1DIntArray}
                    items={scaleUp1DStrArray}
                    itemIndex={intervAreaObjList[intervAreaCurrID - 1][intervAreaObjC.scaleUpCurrID]}
                    key={"scaleUpComboBox" + row}
                    style={{
                        color: Theme.blackColor,
                        fontFamily: Theme.fontFamily,
                    }}
                    width={scaleUpColWidth - 50}
                />
            );

            return scaleUpComboBox;
        };

        let GBColWidths = [hiddenColWidth, includeColWidth, intervAreaColWidth, scaleUpColWidth];
        let WordWrappedCols = [false, false, false, false];
        let rowIDs1DIntArray = [];
        let resultsTable2DArray = [];
        let lockedCells2DBoolArray = [];
        let checkBoxState2DBoolArray = [];
        let hasCheckBox2DBoolArray = [];
        let max2DIntArray = [];
        let min2DIntArray = [];
        let hAlignments2DIntArray = [];
        let fontColors2DIntArray = [];
        /* In order to display components in the table, we need to give packTable a 2D array of keys, one per cell. The keys
           will correspond to the images we want to show and should all be unique. If the cell should not show an
           image, we will set its key to null. */
        let componentKeysStr2DArray = [];

        let intervAreaCurrID = 1;
        for (let r = 1; r <= numRows; r++) {
            resultsTable2DArray.push([]);
            lockedCells2DBoolArray.push([]);
            checkBoxState2DBoolArray.push([]);
            hasCheckBox2DBoolArray.push([]);
            max2DIntArray.push([]);
            min2DIntArray.push([]);
            hAlignments2DIntArray.push([]);
            fontColors2DIntArray.push([]);
            componentKeysStr2DArray.push([]);
            let scaleUpComboBoxKey = null;

            if (r !== 1) {
                rowIDs1DIntArray.push(intervAreaObjList[intervAreaCurrID - 1][intervAreaObjC.scaleUpCurrID]);

                /* We can't pass indCurrID directly to GetScaleUpComboBox, since it
                   will get executed later on after indCurrID has finished incrementing. */
                const intervAreaCurrIDPassed = intervAreaCurrID;
                const rowPassed = r;

                //if (intervAreaObjList[intervAreaCurrID - 1].includeBool) {
                scaleUpComboBoxKey = "scaleUpComboBox" + (r - 1);
                const scaleUpComboBox = (props) => (
                    <GetScaleUpComboBox intervAreaCurrID={intervAreaCurrIDPassed} row={rowPassed} />
                );
                frameworkComponents = addFrameworkComponent(frameworkComponents, scaleUpComboBoxKey, scaleUpComboBox);

                //}
            } else {
                rowIDs1DIntArray.push(0);
            }

            for (let c = 1; c <= numCols; c++) {
                if (r === 1) {
                    if (c === checkBoxCol) {
                        resultsTable2DArray[r - 1].push("Include?");
                    } else if (c === intervAreaCol) {
                        resultsTable2DArray[r - 1].push("Intervention area");
                    } else if (c === scaleUpCol) {
                        resultsTable2DArray[r - 1].push("Scale-up scenario");
                    } else {
                        resultsTable2DArray[r - 1].push("");
                    }

                    lockedCells2DBoolArray[r - 1].push(true);
                    checkBoxState2DBoolArray[r - 1].push(false);
                    hasCheckBox2DBoolArray[r - 1].push(false);

                    hAlignments2DIntArray[r - 1].push(hAlign.center);
                    componentKeysStr2DArray[r - 1].push(null);
                } else {
                    if (c === checkBoxCol) {
                        resultsTable2DArray[r - 1].push("");
                        lockedCells2DBoolArray[r - 1].push(true);
                        checkBoxState2DBoolArray[r - 1].push(
                            intervAreaObjList[intervAreaCurrID - 1][intervAreaObjC.includeBool]
                        );
                        hasCheckBox2DBoolArray[r - 1].push(true);
                        hAlignments2DIntArray[r - 1].push(hAlign.center);
                        componentKeysStr2DArray[r - 1].push(null);
                    } else if (c === intervAreaCol) {
                        resultsTable2DArray[r - 1].push(
                            intervAreaObjList[intervAreaCurrID - 1][intervAreaObjC.name][english]
                        );
                        lockedCells2DBoolArray[r - 1].push(true);
                        checkBoxState2DBoolArray[r - 1].push(false);
                        hasCheckBox2DBoolArray[r - 1].push(false);
                        hAlignments2DIntArray[r - 1].push(hAlign.left);
                        componentKeysStr2DArray[r - 1].push(null);
                    } else if (c === scaleUpCol) {
                        resultsTable2DArray[r - 1].push("");
                        lockedCells2DBoolArray[r - 1].push(true);
                        checkBoxState2DBoolArray[r - 1].push(false);
                        hasCheckBox2DBoolArray[r - 1].push(false);
                        hAlignments2DIntArray[r - 1].push(hAlign.center);

                        //if (intervAreaObjList[intervAreaCurrID - 1].includeBool) {

                        componentKeysStr2DArray[r - 1].push(scaleUpComboBoxKey);

                        // }
                        // else {
                        //
                        //     componentKeysStr2DArray[r - 1].push(null);
                        //
                        // }
                        //
                    } else {
                        resultsTable2DArray[r - 1].push("");
                        lockedCells2DBoolArray[r - 1].push(true);
                        checkBoxState2DBoolArray[r - 1].push(false);
                        hasCheckBox2DBoolArray[r - 1].push(false);
                        hAlignments2DIntArray[r - 1].push(hAlign.center);
                        componentKeysStr2DArray[r - 1].push(null);
                    }
                }

                /* These should be 0 when entering strings. Since we're not entering numbers,
                   might as well set to 0 for the entire table. */
                max2DIntArray[r - 1].push(0);
                min2DIntArray[r - 1].push(0);

                // if ((r % 2) !== 0) {
                //
                //     fontColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.whiteColor)));
                //
                // }
                // else {

                fontColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.blackColor)));

                //}
            }

            if (r !== 1) {
                intervAreaCurrID++;
            }
        }

        const packTable = {
            Alignments: hAlignments2DIntArray,
            BandsOn: true,
            components: componentKeysStr2DArray,
            CheckBoxState: checkBoxState2DBoolArray,
            FontColors: fontColors2DIntArray,
            GBColCount: numCols,
            GBColWidths: GBColWidths,
            GBFixedCols: 1,
            GBFixedRows: 1,
            HasCheckBox: hasCheckBox2DBoolArray,
            id: "intervAreaPackTable",
            key: "intervAreaPackTable",
            LockedCells: lockedCells2DBoolArray,
            MaxAllowedVal: max2DIntArray,
            MinAllowedVal: min2DIntArray,
            GBRowCount: numRows,
            RowIds: rowIDs1DIntArray,
            tableData: {
                value: resultsTable2DArray,
            },
            title: "Intervention areas",
            WordWrappedCols: WordWrappedCols,
        };

        intervAreasTable = (
            <GbStdTable
                disablePopupMenu={true}
                font={"lato"}
                frameworkComponents={frameworkComponents}
                headerBackgroundColor={Theme.HL_PrimaryColor}
                key={"intervAreasTable"}
                oddRowBackgroundColor={Theme.HL_BandColor}
                packTable={packTable}
                onPackTableChanged={this.onIntervAreaPackTableChange}
                removedMenuNames={GBConst.menuItems.filter((s) => {
                    return s !== "Copy";
                })}
                style={{
                    fontFamily: Theme.fontFamily,
                    marginLeft: Theme.leftIndent,
                    marginTop: Theme.ctrlSpacing,
                    padding: 0,
                }}
            />
        );

        return intervAreasTable;
    };

    renderTextDiv = () => {
        let textDiv = (
            <div
                style={{
                    ...Theme.textFontStyle,
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                }}
            >
                <p
                    style={{
                        ...Theme.pageHeadingFontStyle,
                    }}
                >
                    {HLConst.step2AreaText1}
                    &nbsp;
                    {/*<span style = {Theme.stepSubTextHeadingFontStyle}>*/}
                    {HLConst.step2AreaText2}
                    {/*</span>*/}
                </p>

                <Divider
                    style={{
                        ...Theme.dividerStyle,
                    }}
                />

                <p>
                    Here is where we access LiST to determine the prioritized interventions (based on number of maternal
                    and child lives saved) for the selections you make below.
                </p>

                {/*<ol>*/}
                {/*    <li>*/}
                {/*        Entering your chosen coverage scale-up scenarios by intervention area*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        Selecting your country*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        Providing optional population structure and/or nutritional status information to further*/}
                {/*        customize the prioritized interventions for your setting.*/}
                {/*    </li>*/}
                {/*</ol>*/}

                {/*<p>*/}
                {/*    Once you have made these selections, click “View results”. You will be provided with a*/}
                {/*    list of prioritized interventions (based on number of maternal and child lives saved)*/}
                {/*    for your setting based on the selections you have made. The technical note explaining how*/}
                {/*    these results are generated is available here.*/}
                {/*</p>*/}

                {/*<Divider*/}
                {/*    style = {{*/}
                {/*        ...Theme.dividerStyle,*/}
                {/*    }}*/}
                {/*/>*/}

                {/*<p*/}
                {/*    style = {{*/}
                {/*        ...Theme.labelStyle,*/}
                {/*    }}*/}
                {/*>*/}
                {/*    First, select the intervention areas to include and specify the coverage scale-up scenarios you*/}
                {/*    selected in step 1 for each included intervention area (mandatory).*/}
                {/*</p>*/}

                {/*<p>*/}
                {/*    Note: if you have selected different scale-up scenarios for different camps/settlements,*/}
                {/*    you will need to enter each camp/settlement separately.*/}
                {/*</p>*/}
            </div>
        );

        return textDiv;
    };

    renderOptionalTextDiv = () => {
        let optionalTextDiv = (
            <div
                style={{
                    ...Theme.textFontStyle,
                    marginLeft: Theme.leftIndent,
                }}
            >
                <p>
                    Optionally, to further customize the model you may modify the default population structure and/or
                    select additional nutritional status information (stunting and wasting (GAM)) with data for your
                    humanitarian setting. Note if you do not have this information available the model will still run
                    with data from nationally representative household surveys from your selected country from
                    Demographic and Health Surveys (DHS), Multiple Indicator Cluster Surveys (MICS) and other sources.
                </p>
            </div>
        );

        return optionalTextDiv;
    };

    renderFirstYearPopTable = () => {
        let firstYearPopTable;

        /* Props */
        const props = this.props;
        const firstYearPop2DIntArray = props.firstYearPop2DIntArray;

        /* Const */
        const hAlign = GBConst.hAlign;

        const ageCol = firstYearPopTableC.ageCol;
        const maleCol = firstYearPopTableC.maleCol;
        const femaleCol = firstYearPopTableC.femaleCol;
        const numCols = femaleCol;

        const numHeaderRows = firstYearPopTableC.numHeaderRows;

        /* +1 for total row */
        const numRows = firstYearPop2DIntArray.length + numHeaderRows + 1;

        //let GBColWidths = [hiddenColWidth, includeColWidth, intervAreaColWidth];
        let WordWrappedCols = [false, false, false];
        let resultsTable2DArray = [];
        let lockedCells2DBoolArray = [];
        let max2DIntArray = [];
        let min2DIntArray = [];
        let hAlignments2DIntArray = [];
        let fontColors2DIntArray = [];
        let BGColors2DIntArray = [];

        let maleTotalPop = 0;
        let femaleTotalPop = 0;

        let a = 1;
        for (let r = 1; r <= numRows; r++) {
            resultsTable2DArray.push([]);
            lockedCells2DBoolArray.push([]);
            max2DIntArray.push([]);
            min2DIntArray.push([]);
            hAlignments2DIntArray.push([]);
            fontColors2DIntArray.push([]);
            BGColors2DIntArray.push([]);

            let s = 1;
            for (let c = 1; c <= numCols; c++) {
                /* Row header */
                if (r === 1) {
                    if (c === ageCol) {
                        resultsTable2DArray[r - 1].push("Age");
                    } else if (c === maleCol) {
                        resultsTable2DArray[r - 1].push("Male %");
                    } else if (c === femaleCol) {
                        resultsTable2DArray[r - 1].push("Female %");
                    } else {
                        resultsTable2DArray[r - 1].push("");
                    }

                    lockedCells2DBoolArray[r - 1].push(true);
                    hAlignments2DIntArray[r - 1].push(hAlign.center);
                    fontColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.blackColor)));
                    max2DIntArray[r - 1].push(0);
                    BGColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor("yellow")));
                } else if (r < numRows) {
                    /* Age group rows */
                    if (c === ageCol) {
                        resultsTable2DArray[r - 1].push(getAgeGroupStr(a));
                        lockedCells2DBoolArray[r - 1].push(true);
                        hAlignments2DIntArray[r - 1].push(hAlign.left);
                        max2DIntArray[r - 1].push(0);
                        BGColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.whiteColor)));
                    } else if (c === maleCol) {
                        maleTotalPop += firstYearPop2DIntArray[a - 1][s - 1];
                        resultsTable2DArray[r - 1].push(firstYearPop2DIntArray[a - 1][s - 1]);
                        lockedCells2DBoolArray[r - 1].push(false);
                        hAlignments2DIntArray[r - 1].push(hAlign.right);
                        max2DIntArray[r - 1].push(100);
                        BGColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.HL_FormYellowColor)));
                    } else if (c === femaleCol) {
                        femaleTotalPop += firstYearPop2DIntArray[a - 1][s - 1];
                        resultsTable2DArray[r - 1].push(firstYearPop2DIntArray[a - 1][s - 1]);
                        lockedCells2DBoolArray[r - 1].push(false);
                        hAlignments2DIntArray[r - 1].push(hAlign.right);
                        max2DIntArray[r - 1].push(100);
                        BGColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.HL_FormYellowColor)));
                    } else {
                        resultsTable2DArray[r - 1].push("");
                        lockedCells2DBoolArray[r - 1].push(true);
                        hAlignments2DIntArray[r - 1].push(hAlign.center);
                        max2DIntArray[r - 1].push(0);
                        BGColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.whiteColor)));
                    }

                    fontColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.blackColor)));
                } else {
                    /* Total row */
                    if (c === ageCol) {
                        resultsTable2DArray[r - 1].push("Total");
                        hAlignments2DIntArray[r - 1].push(hAlign.left);
                        fontColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.blackColor)));
                        max2DIntArray[r - 1].push(0);
                    } else if (c === maleCol) {
                        resultsTable2DArray[r - 1].push(parseFloat(maleTotalPop.toFixed(0)));
                        hAlignments2DIntArray[r - 1].push(hAlign.right);
                        fontColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.darkGrayColor)));
                        max2DIntArray[r - 1].push(100);
                    } else if (c === femaleCol) {
                        resultsTable2DArray[r - 1].push(parseFloat(femaleTotalPop.toFixed(0)));
                        hAlignments2DIntArray[r - 1].push(hAlign.right);
                        fontColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.darkGrayColor)));
                        max2DIntArray[r - 1].push(100);
                    } else {
                        resultsTable2DArray[r - 1].push("");
                        hAlignments2DIntArray[r - 1].push(hAlign.center);
                        fontColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.blackColor)));
                        max2DIntArray[r - 1].push(0);
                    }

                    lockedCells2DBoolArray[r - 1].push(true);
                    BGColors2DIntArray[r - 1].push(toBase10(getDelphiHexFromHexColor(Theme.whiteColor)));
                }

                min2DIntArray[r - 1].push(0);

                if (c > 1) {
                    s++;
                }
            }

            if (r > 1 && r < numRows) {
                a++;
            }
        }

        const packTable = {
            Alignments: hAlignments2DIntArray,
            BandsOn: true,
            BGColors: BGColors2DIntArray,
            FontColors: fontColors2DIntArray,
            GBColCount: numCols,
            //GBColWidths         : GBColWidths,
            GBFixedCols: 1,
            GBFixedRows: 1,
            id: "firstYearPopPackTable",
            key: "firstYearPopPackTable",
            LockedCells: lockedCells2DBoolArray,
            MaxAllowedVal: max2DIntArray,
            MinAllowedVal: min2DIntArray,
            GBRowCount: numRows,
            tableData: {
                value: resultsTable2DArray,
            },
            title: "First year population",
            WordWrappedCols: WordWrappedCols,
        };

        firstYearPopTable = (
            <GbStdTable
                font={"lato"}
                headerBackgroundColor={Theme.HL_PrimaryColor}
                key={"firstYearPopTable"}
                oddRowBackgroundColor={Theme.HL_BandColor}
                packTable={packTable}
                onPackTableChanged={this.onFirstYearPopPackTableChange}
                // ref                   = {this.state.firstYearPopTableRef} //markRef
                removedMenuNames={GBConst.menuItems.filter((s) => {
                    return s !== "Normalize" && s !== "Copy";
                })}
                style={{
                    fontFamily: Theme.fontFamily,
                    marginLeft: Theme.leftIndent,
                    marginTop: Theme.ctrlSpacing,
                    padding: 0,
                }}
            />
        );

        return firstYearPopTable;
    };

    render() {
        const props = this.props;
        const countryCodeInt = props.countryCodeInt;
        const countryObjList = props.countryObjList;
        // const onDrawerChange = props.onDrawerChange;
        const stuntingIndCurrID = props.stuntingIndCurrID;
        const wastingIndCurrID = props.wastingIndCurrID;
        const intervAreaObjList = props.intervAreaObjList;
        const intervObjList = props.intervObjList;

        const state = this.state;
        const showIntervTreeDialog = state.showIntervTreeDialog;
        const calculating = state.calculating;
        // const changingCountry = state.changingCountry;

        const labelStyle = {
            ...Theme.labelStyle,
            marginLeft: Theme.leftIndent,
            marginTop: Theme.topIndent,
        };

        // const radioGroupStyle = {
        //     marginLeft: Theme.leftIndent,
        //     marginTop: Theme.topIndent / 2,
        //     padding: 0,
        // };

        let firstYearPopLab = null;
        let firstYearPopTable = null;
        // let normalizeBtn = null;
        let intervTreeDialog = null;
        let calculatingDialog = null;

        const infoBtn = (
            <IconButton
                onClick={this.onIntervAreaInfoClick}
                style={{
                    color: Theme.HL_SecondaryColor,
                    cursor: "pointer",
                    display: "inline-block",
                    marginLeft: indent,
                    padding: 0,
                }}
            >
                <Info
                    style={{
                        color: Theme.HL_SecondaryColor,
                    }}
                />
            </IconButton>
        );

        const intervAreasLab = (
            <div>
                <TLabel
                    caption={
                        "1. Select the intervention areas to include and specify the coverage " +
                        "scale-up scenarios you determined in the previous step (mandatory)."
                    }
                    key={"selectIntervAreasLab"}
                    pictureRight={infoBtn}
                    style={{
                        ...labelStyle,
                        //display : "inline-block",
                    }}
                />
                <p style={{ marginLeft: 20, marginTop: 0, marginBottom: 0 }}>
                    Note: if you have selected different scale-up scenarios for different humanitarian contexts, you
                    will need to enter each humanitarian context separately.
                </p>
            </div>
        );

        const intervAreasTable = this.renderIntervAreasTable();

        const countryLab = (
            <TLabel caption={"2. Select a country (mandatory)."} key={"countryLab"} style={labelStyle} />
        );

        const countryComboBox = (
            <>
                <TComboBox
                    info={getCountryMstIDs(countryObjList)}
                    itemIndex={getCountryIdx(countryObjList, countryCodeInt)}
                    items={getCountryNames(countryObjList)}
                    outerStyle={{
                        fontFamily: Theme.fontFamily,
                        marginLeft: Theme.leftIndent,
                        marginTop: 5,
                    }}
                    style={{
                        fontFamily: Theme.fontFamily,
                    }}
                    // onChange={this.onCountryComboBoxChange}
                    onChange={() => alert("Changing countries has been disabled.")}
                />
            </>
        );

        firstYearPopLab = (
            <TLabel
                caption={
                    "3. Modify the first year population for each age group as a proportion of the total " +
                    "first year population (%) (optional)."
                }
                key={"firstYearPopLab"}
                style={labelStyle}
            />
        );

        firstYearPopTable = this.renderFirstYearPopTable();

        // if (countryCodeInt !== HLConst.noCountrySelected) {
        //
        //     normalizeBtn =
        //         <TButton
        //             caption        = {"Normalize"}
        //             captionStyles  = {{
        //                 fontSize     : 16,
        //                 ...Theme.labelFontStyle,
        //                 marginTop    : 5,
        //                 marginBottom : 5,
        //             }}
        //             containerStyle = {{
        //                 display      : "inline-block",
        //                 fontFamily   : Theme.fontFamily,
        //                 marginBottom : 20,
        //                 marginLeft   : Theme.leftIndent,
        //                 marginTop    : Theme.topIndent,
        //             }}
        //             key            = {"nextBtn"}
        //             style          = {{
        //                 fontFamily : Theme.fontFamily,
        //             }}
        //             onClick        = {this.onNormalizeBtnClick}
        //         />;
        //
        // }

        const stuntingLab = (
            <TLabel
                caption={"4. Select an indicator for stunting, ages 6-59 months (optional)."}
                key={"stuntingLab"}
                style={labelStyle}
            />
        );

        const stuntingInfo = [
            "Acceptable < 10%",
            "Poor >= 10 - < 20%",
            "Serious >= 20 - < 30%",
            "Critical >= 30%",
            "Unsure/data not available",
        ];

        const stuntingComboBox = (
            <TComboBox
                //info      = {stuntingInfo}
                itemIndex={stuntingIndCurrID - 1}
                items={stuntingInfo}
                style={{
                    fontFamily: Theme.fontFamily,
                }}
                outerStyle={{
                    fontFamily: Theme.fontFamily,
                    marginLeft: Theme.leftIndent,
                    marginTop: 5,
                }}
                onChange={this.onStuntingComboBoxChange}
            />
        );

        const wastingLab = (
            <TLabel
                caption={
                    "5. Select an indicator for wasting using global acute malnutrition (GAM), " +
                    "ages 6-59 months (optional)."
                }
                key={"wastingLab"}
                style={labelStyle}
            />
        );

        const wastingInfo = [
            "Acceptable < 5%",
            "Poor >= 5 - < 10%",
            "Serious >= 10 - < 15%",
            "Critical >= 15%",
            "Unsure/data not available",
        ];

        const wastingComboBox = (
            <TComboBox
                //info      = {wastingInfo}
                itemIndex={wastingIndCurrID - 1}
                items={wastingInfo}
                outerStyle={{
                    fontFamily: Theme.fontFamily,
                    marginLeft: Theme.leftIndent,
                    marginTop: 5,
                }}
                style={{
                    fontFamily: Theme.fontFamily,
                }}
                onChange={this.onWastingComboBoxChange}
            />
        );

        const viewResultsBtn = (
            <>
                <TButton
                    caption={"View results is disabled"}
                    captionStyles={{
                        fontSize: 16,
                        ...Theme.labelFontStyle,
                        marginTop: 5,
                        marginBottom: 5,
                    }}
                    containerStyle={{
                        display: "block",
                        fontFamily: Theme.fontFamily,
                        marginBottom: indent,
                        marginLeft: Theme.leftIndent,
                        marginTop: Theme.topIndent,
                    }}
                    style={{
                        backgroundColor: Theme.HL_BtnBackgroundColor,
                        fontFamily: Theme.fontFamily,
                    }}
                    disabled={true}
                    onClick={() => {}}
                />
                {/* <TButton
                caption={"View results"}
                captionStyles={{
                    fontSize: 16,
                    ...Theme.labelFontStyle,
                    marginTop: 5,
                    marginBottom: 5,
                }}
                containerStyle={{
                    display: "block",
                    fontFamily: Theme.fontFamily,
                    marginBottom: indent,
                    marginLeft: Theme.leftIndent,
                    marginTop: Theme.topIndent,
                }}
                disabled={changingCountry}
                style={{
                    backgroundColor: Theme.HL_BtnBackgroundColor,
                    fontFamily: Theme.fontFamily,
                }}
                onClick={this.onViewResultsBtnClick}
            /> */}
            </>
        );

        if (showIntervTreeDialog) {
            intervTreeDialog = (
                <HLIntervTreeDialog
                    onDialogClose={this.onIntervAreaDialogClose}
                    intervAreaObjList={intervAreaObjList}
                    intervObjList={intervObjList}
                />
            );
        }

        if (calculating) {
            const captionDiv = (
                <div
                    style={{
                        color: Theme.HL_PrimaryColor,
                        fontSize: "20px",
                    }}
                >
                    {"Communicating with LiST / SpectrumWeb..."}
                </div>
            );

            const wifiAnimationIcon = (
                <TWifiAnimation
                    style={{
                        marginRight: "20px",
                        float: "left",
                    }}
                />
            );

            const contentDiv = (
                <div>
                    <div
                        style={{
                            fontSize: "16px",
                            color: "gray",
                        }}
                    >
                        {"Calculating intervention impact..."}
                    </div>

                    <div
                        style={{
                            fontSize: "12px",
                        }}
                    >
                        <br />
                        {"Working on: Calculating intervention impact"}
                    </div>
                </div>
            );

            calculatingDialog = (
                <TDialog
                    caption={captionDiv}
                    header={""} // needed for dialog to show icon and caption
                    icon={wifiAnimationIcon}
                    //message = {"Communicating with SpectrumWeb..."}
                    content={contentDiv}
                    modal={true}
                    visible={true}
                    actions={[]}
                    style={{
                        width: "575px",
                    }}
                />
            );
        }

        const exampleDiv = (
            <div
                style={{
                    ...Theme.exampleDivStyle,
                    marginLeft: 20,
                }}
            >
                <p>
                    <span
                        style={{
                            textDecoration: "underline",
                        }}
                    >
                        For example:
                    </span>
                    &nbsp;Choose the 60% to 80% coverage scale-up scenario for Nutrition and the 90% to 95% scale-up
                    scenario for EPI (determined in step 1). Then select your country, for example Uganda. Since you
                    know there are a lot of U5s at your camp, change the U5 % for both men and women to 15%. Select the
                    “serious” option for stunting based on your camp’s most recent survey which indicated a stunting
                    rate in the 6-59 month population of 25%, and leave the default “unsure/data not available” option
                    for wasting as you do not have recent survey data for this indicator.
                </p>
            </div>
        );

        //const downloadGuideBtn =
        //    <HLDownloadGuideBtn/>;

        const navBtnDiv = (
            <HLNavBtnDiv
                onBackBtnClick={() => this.onPageChange(HLConst.step1Form)}
                onNextBtnClick={() => this.onPageChange(HLConst.step3Form)}
            />
        );

        return (
            <React.Fragment>
                {this.renderTextDiv()}
                {intervAreasLab}
                {intervAreasTable}
                {countryLab}
                {countryComboBox}
                {this.renderOptionalTextDiv()}
                {firstYearPopLab}
                {firstYearPopTable}
                {/*{normalizeBtn}*/}
                {stuntingLab}
                {stuntingComboBox}
                {wastingLab}
                {wastingComboBox}
                {viewResultsBtn}
                {exampleDiv}
                {navBtnDiv}
                {/*{downloadGuideBtn}*/}
                {intervTreeDialog}
                {calculatingDialog}
            </React.Fragment>
        );
    }
}

export default HLStep2Form;
